import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./index.module.scss";
import Utils from "@utils/utils";
import { ProjectContext } from "../../hooks/ProjectContext";
import { AppContext } from "@utils/AppContext";
import { IMAGE_TYPE } from "@utils/CONST";

const list = [
    {
        title: "AI商拍图",
        key: "model",
        img_nomal: "https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/pro_side_icon1_nomal.svg",
        img_active: "https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/pro_side_icon1_active.svg",
    },
    {
        title: "AI创意生图",
        key: IMAGE_TYPE.CREATIVE_IMAGE_GEN,
        img_nomal: "https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/pro_side_icon2_nomal.svg",
        img_active: "https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/pro_side_icon2_active.svg",
    },
    {
        title: "AI视频",
        key: "modelVideo",
        img_nomal: "https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/pro_side_icon4_nomal.svg",
        img_active: "https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/pro_side_icon4_active.svg",
    },
    {
        title: "AI工具箱",
        key: "aiEdit",
        img_nomal: "https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/pro_side_icon3_nomal.svg",
        img_active: "https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/pro_side_icon3_active.svg",
    },
    {
        title: "企业版",
        key: "bachImage",
        img_nomal: "https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/batchImahe_nomal.svg",
        img_active: "https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/batchImahe_active.svg",
    },
];

const ProjectSidebar = () => {
    const navigate = useNavigate();
    const { setProFunction } = useContext(ProjectContext);
    const { proSidebarValue, setProSidebarValue } = useContext(AppContext);

    useEffect(() => {
        if (proSidebarValue == "bachImage") {
            navigate("/home/myProject/batchImages", {
                state: {
                    isProCenter: true,
                },
            });
        }
    }, [proSidebarValue, navigate]);

    const handleClick = (key) => {
        setProFunction(key === IMAGE_TYPE.CREATIVE_IMAGE_GEN ? IMAGE_TYPE.CREATIVE_IMAGE_GEN : "");
        setProSidebarValue(key);
        navigate("/home/myProject/list");
        if (key == "bachImage") {
            navigate("/home/myProject/batchImages", {
                state: {
                    isProCenter: true,
                },
            });
        }
    };

    const getSidebarIconUrl = (url) => {
        if (!url) return url;
        if (/\.svg(\?|$)/i.test(url)) return url;
        return Utils.getImgThumbnail(url);
    };

    return (
        <div className={styles.ProjectSidebar}>
            {list.map((item) => (
                <div className={styles.ProjectSidebarItem} key={item.key} onClick={() => { handleClick(item.key); }}>
                    <div className={`${styles.ProjectSidebarItemContent} ${proSidebarValue == item.key ? styles.ProjectSidebarItemContentActive : ""}`}>
                        <img
                            className={`${styles.ProjectSidebarIcon} ${proSidebarValue == item.key ? styles.ProjectSidebarIconActive : ""}`}
                            src={getSidebarIconUrl(proSidebarValue == item.key ? item.img_active : item.img_nomal)}
                            alt=""
                        />
                        <p className={`${styles.ProjectSidebarTitle} ${proSidebarValue == item.key ? styles.ProjectSidebarTitleActive : ""}`}>
                            {item.title}
                        </p>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ProjectSidebar;
